import React, { useEffect } from 'react';

import { FormProvider, useForm } from 'react-hook-form';
import { useToggle } from 'react-use';
import { observer } from 'mobx-react';

import { YesNoBtnRow } from '@infoods/lifebase-ui';

import classes from './NgzScholasticCustomerProfile.module.scss';
import { angularizeWithProviders } from '../../../../../../shared/providers';
import { ScholasticProfileInputs } from '../../../../../components/ScholasticProfileInputs/ScholasticProfileInputs';
import { getRouteParam } from '../../../../../../shared/utils/angularUtils';
import { ScholasticUserDataFormValue } from '../../../../../interfaces/ScholasticUserProfileFormValue';
import { scholasticCustomerService } from '../../../../../services/scholasticCustomerService';
import { getFilteredTruthyFieldsObj } from '../../../../../../shared/utils/sortingAndGroupingUtil';
import { LbModal } from '../../../../../../shared/components/modals/LbModal/LbModal';
import { useSchoolsList } from '../../../../../../shared/hooks/schools/useSchoolsList';

const NgzScholasticCustomerProfile = observer(() => {
  const [isShowSuccessModal, toggleShowSuccessModal] = useToggle(false);
  const { schoolList } = useSchoolsList({ onlyActive: true, isScholastic: true });
  const methods = useForm<ScholasticUserDataFormValue>();
  const { reset, handleSubmit, formState } = methods;

  const userId = getRouteParam('id');
  const initUserInfo = async () => {
    // TODO set more info when form need, add function to delate unused field
    const userData = await scholasticCustomerService.getUserData(userId);
    const clearedUserData = getFilteredTruthyFieldsObj(userData);

    reset({ userData: clearedUserData });
  };

  const onSubmit = async ({ userData }: ScholasticUserDataFormValue) => {
    await scholasticCustomerService.sendUser(userData);

    toggleShowSuccessModal();
  };

  useEffect(() => {
    initUserInfo();
  }, []);

  return (
    <>
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmit)} noValidate>
          <ScholasticProfileInputs
            affiliateList={schoolList}
            isShowAddress
            className={classes.inputBlock}
          />
          <YesNoBtnRow yesText="Save" yesDisabled={!formState.isDirty} />
        </form>
      </FormProvider>
      <LbModal
        open={isShowSuccessModal}
        title="Changes have been saved successfully"
        onClose={toggleShowSuccessModal}
        primaryBtnConfig={{ text: 'Ok', onClick: toggleShowSuccessModal }}
      />
    </>
  );
});

angularizeWithProviders(NgzScholasticCustomerProfile, 'ngzScholasticCustomerProfile', {});

export { NgzScholasticCustomerProfile };
